import { defineComponent as _defineComponent } from 'vue'
import { computed } from '../../../../adapter-vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'message-tip',
  props: {
  content: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props


const tipContent = computed(() => props.content?.text || props.content?.custom || '');

return { __sfc: true,props, tipContent }
}

})